import { Observable, Subject } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';

const sessionStart$ = new Subject<void>();

/** Emette a ogni restart: per i listener con stato proprio (closure/oggetti di stato) da riallineare al nuovo verbale. */
export const listenerSessionStart$: Observable<void> = sessionStart$.asObservable();

/** Nuova sessione di verbale: gli operatori "on change" ripartono dal valore corrente dei controlli, come dopo un F5. */
export const restartListenerSessions = (): void => sessionStart$.next();

/** Costruisce la pipeline subito e la ricostruisce a ogni restart (seed riletto, memoria azzerata). */
export const perListenerSession =
    <T, R>(build: (source$: Observable<T>) => Observable<R>) =>
    (source$: Observable<T>): Observable<R> =>
        sessionStart$.pipe(
            startWith(undefined),
            switchMap(() => build(source$))
        );
